import {RoomLinks} from '@findhotel/sapi'
import {ActionLinkTypes} from '@daedalus/core/src/offer/types/actionLink'
import {StoreStateType} from '..'
import {
  OfferPrice,
  CancellationPenalty
} from '@daedalus/core/src/offer/types/offer'

import {OfferCheckState} from './slice'

export const getOfferCheck = (state: StoreStateType): OfferCheckState => {
  return state?.offerCheck
}

export const getModuleState = (state: StoreStateType) =>
  state?.offerCheck?.moduleState

export const getOfferCheckPrices = (state: StoreStateType): OfferPrice[] => {
  return state?.offerCheck?.prices
}

export const getIsOfferCheckLoaded = (state: StoreStateType) =>
  state?.offerCheck?.loaded

export const getOfferCheckPaymentLink = (state: StoreStateType): RoomLinks =>
  state?.offerCheck?.links.find(
    link => link.type === ActionLinkTypes.PAYMENT_OPTIONS
  )

export const getOfferCheckCancellationPenalties = (
  state: StoreStateType
): CancellationPenalty[] => state?.offerCheck?.cancellationPenalties

export const getOfferCheckRefundable = (state: StoreStateType): boolean =>
  state?.offerCheck?.refundable

export const getBookOfferCreationLink = (state: StoreStateType) =>
  state?.offerCheck?.links?.find(
    link => link.type === ActionLinkTypes.BOOKING_CREATION
  )
